import { render } from "./BusinessTable.vue?vue&type=template&id=4fbd6957&scoped=true"
import script from "./BusinessTable.vue?vue&type=script&lang=js"
export * from "./BusinessTable.vue?vue&type=script&lang=js"

import "./BusinessTable.vue?vue&type=style&index=0&id=4fbd6957&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fbd6957"]])

export default __exports__